<template>
  <v-card flat tile color="">
    <v-main style="overflow-x:hidden">
      <router-view></router-view>
    </v-main>
  </v-card>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted(){
        this.$store.dispatch("loadVendor")
  }
};
</script>
